import React from 'react'
import { Label } from 'semantic-ui-react'

import utils from '../../../../../utils'

export default class AssignedDriver extends React.PureComponent {
  render() {
    const { driver, delivererInProgressOrders } = this.props
    const driverName = `${driver.family_name} ${driver.first_name}`
    const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(driver.tel)

    return (
      <React.Fragment>
        {
          delivererInProgressOrders.length > 1 && (
            <div style={{ fontSize: 12, fontWeight: 'bold', color: 'rgb(255, 113, 57)' }}>
              Orders: { delivererInProgressOrders.length}
            </div>
          )
        }
        <div>
          <strong>{driverName}</strong>
        </div>

        <div>
          <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
            <Label style={{ marginTop: 5, width: 120 }}>{driver.tel}</Label>
          </a>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/AssignedDriver.js